// utils/orderHelpers.js

export function formatDateTime(dateString) {
  if (!dateString) return "N/A";
  
  const date = new Date(dateString);
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };
  
  return date.toLocaleDateString("en-US", options);
}

export function calculateOrderTotal(order) {
  if (!order.Items || order.Items.length === 0) return { subtotal: 0, discount: 0 };

  let subtotal = 0;
  let discount = 0;

  order.Items.forEach((item) => {
    const variation = item.Variations?.[0];
    const price = variation?.Price || 0;
    const qty = item.Quantity || 1;

    // Base price
    let itemTotal = price;

    // Add addon prices
    variation?.ItemChoices?.forEach((choice) => {
      choice.ItemOptions?.forEach((option) => {
        itemTotal += (option.Price || 0) * (option.Quantity || 1);
      });
    });

    subtotal += itemTotal * qty;

    // Discount (applied on base price only, not addons)
    const disc = variation?.Discount;
    if (disc) {
      const discountAmount = disc.Type === "Percentage" ? (price * disc.Value) / 100 : disc.Value || 0;
      discount += discountAmount * qty;
    }
  });

  return { subtotal, discount };
}

export function getStatusColor(status) {
  const colors = {
    Pending: "yellow",
    Processing: "blue",
    Completed: "green",
    Cancelled: "red",
    Delivered: "purple",
  };
  return colors[status] || "gray";
}